import { TextAreaField, TextField } from "components/Form";
import { MaskedTextField } from "components/Form/MaskedTextField";

import { FieldType } from "../../queues/types/FieldType";
import { IEReservationQueueFormField } from "../../queues/types/IEReservationQueueFormField";

interface IProps {
  field: IEReservationQueueFormField;
}

const QueueField = ({ field }: IProps) => {
  switch (field.fieldType) {
    case FieldType.TextArea:
      return (
        <TextAreaField
          label={field.label}
          name={field.name}
          isRequired={field.required}
        />
      );
    case FieldType.TextField:
      return (
        <TextField
          label={field.label}
          name={field.name}
          isRequired={field.required}
        />
      );
    case FieldType.PhoneField:
      return (
        <MaskedTextField
          mask={[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
          name={field.name}
          label={field.label}
          isRequired={field.required}
        />
      );
    default:
      return <></>;
  }
};

export { QueueField };
